import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
} from "@material-ui/core";
import Axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import CustomDialog from "../../../../Component/DialogBox/CustomDialog";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { adminLogout } from "../../../../redux/action/action";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./ApprovedBooks.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import SearchFilterBook from "../SearchFilterBook/SearchFilterBook";

class ApprovedBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      search: {
        title: "",
        authorFirstName: "",
        authorLastName: "",
        publishedDate: "",
        genre: "",
      },
      genreSet: [],
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Title",
        },
        {
          name: "Author",
        },
        {
          name: "Genre",
        },
        {
          name: "Published Date",
        },
        {
          name: "Actions",
        },
      ],
      book: [],
      dialogOpen: false,
      isEmpty: false,
      bookIdToDelete: "",
      notificationOpen: false,
      sessionExpired: false,
    };
  }

  componentDidMount() {
    this.getData();
    this.getGenreData();
  }

  getData = async () => {
    try {
      const { data } = await Axios.get(`${url}/api/books/allBooks`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      if (data.length !== 0) {
        let filter = data.filter((item) => item.bookVerified === true);
        if (filter.length !== 0) {
          this.setState({
            book: filter,
            isEmpty: false,
          });
        } else {
          this.setState({
            book: [],
            isEmpty: true,
          });
        }
      } else {
        this.setState({
          book: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.resposne.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  getGenreData = async () => {
    const response = await Axios.get(`${url}/api/categories`);
    if (response.data.length !== 0) {
      this.setState({
        genreSet: response.data,
      });
    } else {
      this.setState({
        genreSet: [],
      });
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: { ...this.state.search, [e.target.name]: e.target.value },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleAdd = () => {
    this.props.history.push("/_administration_/book/add");
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteBook = async () => {
    let response = await Axios.delete(
      `${url}/api/books/${this.state.bookIdToDelete}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.success) {
      this.handleDialogClose();
      this.handleNotificationOpen();
      this.getData();
    }
  };

  handleEditBook = (bookId) => {
    this.props.history.push(`/_administration_/book/edit/${bookId}`);
  };

  handleDetailBook = (bookId) => {
    this.props.history.push(`/_administration_/book/detail/${bookId}`);
  };

  handleDialogOpen = (bookId) => {
    this.setState({
      dialogOpen: true,
      bookIdToDelete: bookId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    const filtered = this.state.book.filter((book) => {
      return (
        book.title
          .toLowerCase()
          .indexOf(this.state.search.title.toLowerCase()) !== -1 &&
        book.author.firstName
          .toLowerCase()
          .indexOf(this.state.search.authorFirstName.toLowerCase()) !== -1 &&
        book.author.lastName
          .toLowerCase()
          .indexOf(this.state.search.authorLastName.toLowerCase()) !== -1 &&
        book.genre
          .toLowerCase()
          .indexOf(this.state.search.genre.toLowerCase()) !== -1 &&
        book.publishedDate.indexOf(this.state.search.publishedDate) !== -1
      );
    });
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}

          <AdminPageTitle
            title="Approved Books"
            refreshUrl={this.props.match.url}
          />
          <Divider />
          <br />

          <SearchFilterBook
            data={this.state.search}
            handleChange={this.handleSearch}
          />

          <div>
            {this.state.book.length !== 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {this.state.column.map((column, index) => (
                        <TableCell
                          key={index}
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filtered
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((book, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: `${index % 2 ? "#eee" : "white"}`,
                          }}
                        >
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">{book.title}</TableCell>
                          <TableCell align="center">
                            {book.author.firstName} {book.author.lastName}
                          </TableCell>
                          <TableCell align="center">{book.genre}</TableCell>
                          <TableCell align="center">
                            {book.publishedDate}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ alignContent: "center" }}
                          >
                            <Tooltip
                              arrow
                              title="View details"
                              className={classes.tooltip}
                              onClick={() => this.handleDetailBook(book._id)}
                            >
                              <InfoIcon />
                            </Tooltip>
                            <Tooltip
                              arrow
                              title="Edit"
                              className={classes.tooltip}
                              onClick={() => this.handleEditBook(book._id)}
                            >
                              <EditIcon />
                            </Tooltip>
                            <Tooltip
                              arrow
                              title="Delete"
                              className={classes.tooltip}
                              onClick={() => this.handleDialogOpen(book._id)}
                            >
                              <DeleteIcon />
                            </Tooltip>
                          </TableCell>
                          <CustomDialog
                            open={this.state.dialogOpen}
                            handleClose={this.handleDialogClose}
                            handleDelete={this.handleDeleteBook}
                          />
                        </TableRow>
                      ))}
                  </TableBody>
                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
                {this.showNotification(classes.notificationStyle)}
              </TableContainer>
            ) : this.state.isEmpty === true ? (
              <CustomEmptyMessage message="No data present in the database" />
            ) : (
              <CustomLoader />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ApprovedBooks)));
